import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {NgSelectModule} from "@ng-select/ng-select";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {ApiService} from "@ctms/api.service";
import {PatientFilter} from "@cdss/pages/dashboard-v2/filter/filter.dto";

@Component({
    selector: 'cdss-dashboard-v2-filter',
    imports: [CommonModule, ReactiveFormsModule, NgSelectModule, NgxDatatableModule],
    providers: [ApiService],
    templateUrl: './dashboard-v2-filter.component.html',
    standalone: true,
    styleUrl: './dashboard-v2-filter.component.scss'
})
export class DashboardV2FilterComponent {

    form!: FormGroup;

    @Output() apply = new EventEmitter<boolean>()
    @Output() cancel = new EventEmitter<{}>()

    _filter!: PatientFilter
    @Output() filterChange = new EventEmitter<PatientFilter>()

    get filter(): PatientFilter {
        return this._filter
    }

    @Input()
    set filter(value: PatientFilter) {
        this._filter = value
        this.initForm()
    }

    constructor(private fb: FormBuilder) {
        this.form = this.fb.group({
            scope: ['all'],
            adherence: this.fb.group({
                low: [false],
                medium: [false],
                high: [false],
            }),
            meedRiskStatus: this.fb.group({
                High: [false],
                Moderate: [false],
                Low: [false],
                Unknown: [false],
            }),
            programStage: this.fb.group({
                early: [false],
                mid: [false],
                late: [false],
            }),
            promsTrend: this.fb.group({
                improving: [false],
                stable: [false],
                deteriorating: [false],
            }),
        });
    }

    ngOnInit() {
    }

    initForm() {
        if (!this.filter) return;

        this.form.reset({
            scope: this.filter.scope,
            adherence: {
                low: this.filter.adherence.includes('low'),
                medium: this.filter.adherence.includes('medium'),
                high: this.filter.adherence.includes('high'),
            },
            meedRiskStatus: {
                High: this.filter.meedRiskStatus.includes('High'),
                Moderate: this.filter.meedRiskStatus.includes('Moderate'),
                Low: this.filter.meedRiskStatus.includes('Low'),
                Unknown: this.filter.meedRiskStatus.includes('Unknown'),
            },
            programStage: {
                early: this.filter.programStage.includes('early'),
                mid: this.filter.programStage.includes('mid'),
                late: this.filter.programStage.includes('late'),
            },
            promsTrend: {
                improving: this.filter.promsTrend.includes('improving'),
                stable: this.filter.promsTrend.includes('stable'),
                deteriorating: this.filter.promsTrend.includes('deteriorating'),
            },
        });
    }

    reset() {
        this.form.reset({
            scope: 'all',
            adherence: {
                low: false,
                medium: false,
                high: false,
            },
            meedRiskStatus: {
                High: false,
                Moderate: false,
                Low: false,
                Unknown: false,
            },
            programStage: {
                early: false,
                mid: false,
                late: false,
            },
            promsTrend: {
                improving: false,
                stable: false,
                deteriorating: false,
            },
        });
        this.filter.search = ""
        this.returnValue()
        this.apply.emit(false)
    }

    applyFilter() {
        this.returnValue()
        this.apply.emit(true)
    }

    mapBooleansToArray(group: Record<string, boolean>): string[] {
        return Object.entries(group)
            .filter(([_, checked]) => checked)
            .map(([key]) => key)
    }

    returnValue() {
        const value = this.form.value
        this.filter.scope = value.scope
        this.filter.adherence = this.mapBooleansToArray(value.adherence)
        this.filter.meedRiskStatus = this.mapBooleansToArray(value.meedRiskStatus)
        this.filter.programStage = this.mapBooleansToArray(value.programStage)
        this.filter.promsTrend = this.mapBooleansToArray(value.promsTrend)
        this.filterChange.emit(this.filter);
    }

    close() {
        this.cancel.emit({});
    }
}
